var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemitPaymentPurpleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49773 6.56072H1.74658V3.80957",
    stroke: "#574B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84326 17.2666C6.66861 17.7444 7.5829 18.0828 8.55681 18.2533",
    stroke: "#653494",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.18848 12.9092C2.52412 13.8299 3.01015 14.6763 3.62824 15.4127",
    stroke: "#653494",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4434 18.2533C12.4173 18.0828 13.3306 17.7444 14.1569 17.2666",
    stroke: "#653494",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3716 15.4127C16.9897 14.6763 17.4757 13.8299 17.8113 12.9092",
    stroke: "#574B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2533 9.99953C18.2533 5.44088 14.5585 1.74609 9.99986 1.74609C6.67098 1.74609 3.80887 3.72142 2.50391 6.5606",
    stroke: "#574B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.37365V6.78949",
    stroke: "#574B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.6259V13.2091",
    stroke: "#574B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48055 11.9995C8.70706 12.3709 9.09405 12.6268 9.56267 12.6268H10.0001H10.5219C11.2014 12.6268 11.7507 12.0765 11.7507 11.3979C11.7507 10.8339 11.3665 10.3433 10.8199 10.2048L9.17842 9.79216C8.63278 9.65552 8.24854 9.1649 8.24854 8.60092C8.24854 7.92138 8.79876 7.37207 9.47738 7.37207H10.0001H10.4375C10.9043 7.37207 11.2913 7.62793 11.5169 7.99841",
    stroke: "#574B89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemitPaymentPurpleIcon);
export default __webpack_public_path__ + "static/media/remit-payment-purple-icon.da881178cb58d145412ea9ec27a474cd.svg";
export { ForwardRef as ReactComponent };